export enum CURRENCIES {
  EUR = 'EUR',
  USD = 'USD',
}
